module.exports = __webpack_public_path__ + "static/img/nav_act_bgc.82882e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/nav_act_bgc.png
// module id = +c5l
// module chunks = 98